import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import { PrivateKeyRecoveryOptionMethodEnum } from '#src/__generated__/globalTypes.ts';
import { walletRecovery } from '#src/contexts/currentUser/queries.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  DeactivateWalletRecoveryEmailMutation,
  DeactivateWalletRecoveryEmailMutationVariables,
} from './__generated__/useDeactivateWalletRecoveryEmail.graphql.ts';

const DEACTIVATE_WALLET_RECOVERY_EMAIL = gql`
  mutation DeactivateWalletRecoveryEmailMutation(
    $input: deactivateWalletRecoveryInput!
  ) {
    deactivateWalletRecovery(input: $input) {
      currentUser {
        slug
        ...CurrentUserProvider_walletRecovery
      }
      errors {
        path
        message
        code
      }
    }
  }
  ${walletRecovery}
` as TypedDocumentNode<
  DeactivateWalletRecoveryEmailMutation,
  DeactivateWalletRecoveryEmailMutationVariables
>;

export const useDeactivateWalletRecoveryEmail = () => {
  const [mutate, { loading }] = useMutation(DEACTIVATE_WALLET_RECOVERY_EMAIL, {
    showErrorsWithSnackNotification: true,
  });

  const deactivateWalletRecoveryEmail = useCallback(
    async (destination: string) => {
      const input = {
        method: PrivateKeyRecoveryOptionMethodEnum.EMAIL,
        destination,
      };
      const result = await mutate({
        variables: {
          input,
        },
      });
      return result;
    },
    [mutate]
  );

  return {
    deactivateWalletRecoveryEmail,
    loading,
  };
};
